var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F3E8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 23.1962V22.5C35 19.365 30.2712 17 24 17C17.7288 17 13 19.365 13 22.5V27.5C13 30.1112 16.2812 32.1863 21 32.8075V33.5C21 36.635 25.7288 39 32 39C38.2712 39 43 36.635 43 33.5V28.5C43 25.9125 39.8225 23.835 35 23.1962ZM19 30.3587C16.5512 29.675 15 28.5487 15 27.5V25.7413C16.02 26.4637 17.3863 27.0463 19 27.4375V30.3587ZM29 27.4375C30.6138 27.0463 31.98 26.4637 33 25.7413V27.5C33 28.5487 31.4487 29.675 29 30.3587V27.4375ZM27 36.3587C24.5513 35.675 23 34.5487 23 33.5V32.9788C23.3287 32.9913 23.6613 33 24 33C24.485 33 24.9587 32.9837 25.4237 32.9562C25.9403 33.1412 26.4665 33.2981 27 33.4263V36.3587ZM27 30.7812C26.0068 30.928 25.004 31.0011 24 31C22.996 31.0011 21.9932 30.928 21 30.7812V27.8075C21.9947 27.9371 22.9969 28.0014 24 28C25.0031 28.0014 26.0053 27.9371 27 27.8075V30.7812ZM35 36.7812C33.0106 37.0729 30.9894 37.0729 29 36.7812V33.8C29.9944 33.9337 30.9967 34.0005 32 34C33.0031 34.0014 34.0053 33.9371 35 33.8075V36.7812ZM41 33.5C41 34.5487 39.4487 35.675 37 36.3587V33.4375C38.6138 33.0462 39.98 32.4637 41 31.7412V33.5Z",
    fill: "#9333EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepayments);
export default __webpack_public_path__ + "static/media/repayments.671ec11052cee633f82f121b92d5b43e.svg";
export { ForwardRef as ReactComponent };